<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @on-load="onLoad"
               @refresh-change="onLoad"
    >
      <template slot="menuLeft">
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          @click="openList(scope.row)"
        >服务项明细
        </el-button>
      </template>
      <template slot="projectSearch" slot-scope="scope">
        <el-select
          v-model="query.project"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value)=>projectChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="projectForm" slot-scope="scope">
        <el-select
          v-model="form.project"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value)=>projectAddChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="moduleTypeNameSearch" slot-scope="scope">
        <el-select
          v-model="query.moduleTypeName"
          placeholder="工单类型"
          style="width: 100%"
          @change="(value)=>moduleTypeNamChange(value,1)"
        >
          <el-option
            v-for="item in moduleTypeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="moduleTypeNameForm" slot-scope="scope">
        <el-select
          v-model="form.moduleTypeName"
          placeholder="工单类型"
          style="width: 100%"
          @change="(value)=>moduleTypeNamChange(value,2)"
        >
          <el-option
            v-for="item in moduleTypeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="subModuleIdForm" slot-scope="scope">
        <el-select
          clearable
          v-model="form.subModuleId"
          placeholder="工单子类型"
          style="width: 100%"
        >
          <el-option
            v-for="item in subModuleList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :disabled="item.status === 0"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="subModuleIdSearch" slot-scope="scope">
        <el-select
          v-model="query.subModuleId"
          clearable
          placeholder="工单子类型"
          style="width: 100%"
          @change="subModuleIdChange(value)"
        >
          <el-option
            v-for="item in subModuleList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
    </avue-crud>
      <itemList ref="itemList" style="display:none"></itemList>
      <!-- v-if="listFlag"  -->
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update} from "@/api/gateservice/order/orderserviceitem/orderserviceitem";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import itemList from "@/views/crmedical/order/orderserviceitem/orderserviceitemlist";
  import {
    modulesSetting
  } from "@/api/gateservice/order/order-add";
  import {
    getAllSubModuleList
  } from "@/api/gateservice/order/order";

  var inputNumber = (rule, value, callback) => {
    var regNumber = /^\+?[1-9][0-9]*$/;
    if (!regNumber.test(value)) {
      callback(new Error('请输入大于 0 的整数！'));
    } else {
      callback();
    }
  };
  export default {
    components:{
      itemList
    },
    data() {
      return {
        moduleTypeList: [],
        subModuleList: [],
        listFlag: false,
        projectList: [],
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 150,
          tip: false,
          border: true,
          index: true,
          selection: false,
          columnBtn: false,
          searchMenuSpan: 24,
          labelWidth: 120,
          searchLabelWidth: 120,
          dialogClickModal:false,
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              type: 'select',
              dicUrl: 'api/v4ward/project/getProjectList',
              props: {
                label: 'name',
                value: 'id',
              },
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              editDisabled: true,
              addDisplay: false,
            },
            {
              label: "项目名称",
              prop: "project",
              search: true,
          searchLabelWidth:90,
              searchslot:true,
              formslot: true,
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }],
              hide: true,
              addDisplay: true,
              editDisplay: false,
              span: 12,
            },
            {
              label: "工单类型",
              prop: "moduleType",
              type: "select",
              dicUrl: "/api/blade-system/dict/dictionary?code=out_order_module_type",
              dataType: "number",
              props: {
                label: "dictValue",
                value: "dictKey",
              },
              display: false,
            },
            {
              label: "工单类型",
              prop: "moduleTypeName",
              searchslot:true,
              formslot: true,
              rules: [{
                required: true,
                message: "请选择工单类型",
                trigger: "change"
              }],
              hide: true,
              search: true,
          searchLabelWidth:90,
            },
            {
              label: "工单子类型",
              prop: "subModuleId",
              searchslot:true,
              formslot: true,
              search: true,
          searchLabelWidth:90,
              hide: true,
              viewDisplay: false,
            },
            {
              label: "工单子类型",
              prop: "subModuleName",
              addDisplay: false,
              editDisplay: false,
            },
            {
              label: "服务名称",
              prop: "name",
              rules: [{
                required: true,
                message: "请输入服务名称",
                trigger: "change"
              }],
              maxlength: 10,
              showWordLimit: true,
              search: true,
          searchLabelWidth:90,
            },
            {
              label: "排序",
              prop: "indexNo",
              rules: [
                {
                  required: true,
                  message: "请输入排序",
                  trigger: "change"
                },
                {
                  validator: inputNumber,
                  trigger: 'blur',
                },
              ],
              maxlength: 3,
              showWordLimit: true,
            },
            {
              label: "备注",
              prop: "remark",
              overHidden: true,
              maxlength: 200,
              showWordLimit: true,
              span: 24,
              type: 'textarea',
            },
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.orderserviceitem_add, false),
          viewBtn: this.vaildData(this.permission.orderserviceitem_view, false),
          delBtn: this.vaildData(this.permission.orderserviceitem_delete, false),
          editBtn: this.vaildData(this.permission.orderserviceitem_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    created: {

    },
    activated(){
      if(this.$refs.crud){
        this.$refs.crud.doLayout();
      }
    },
    deactivated(){
      if(this.$refs.crud){
        this.$refs.crud.doLayout();
      }
    },
    mounted(){
      this.option.height = this.bodyHeight - 380;
      this.$refs.crud.$children[0].$el.querySelector('.avue-form__menu').style = 'text-align:right';
      this.$nextTick(() => {
              // this.reWrite = true;
              console.log(this.bodyHeight);
              setTimeout(()=>{
              console.log(this.$refs.crud)
              console.log(this.$refs.crud.$children[1].$children.length);
              let arrLength = this.$refs.crud.$children[1].$children.length;
              console.log(this.$refs.crud.$children[1].$children[arrLength-2].$el);
              this.$refs.crud.$children[1].$children[arrLength-2].$el.addEventListener("click", ()=>{
                // console.log(1212121)
                console.log("this.option.height=====>",this.option.height);
                    if(this.option.height == this.bodyHeight - 380){
                      this.option.height = this.bodyHeight - 260
                    }else{
                      this.option.height = this.bodyHeight - 380;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })
            });
    },
    methods: {
      subModuleIdChange(){
        this.$forceUpdate();
      },
      getAllSubModuleList(moduleType,projectId){
        getAllSubModuleList({moduleType:moduleType,projectId:projectId}).then((data)=>{
          this.subModuleList = data.data;
          // this.handlerHide(data.data)
        })
      },
      moduleTypeNamChange(value,type){
        console.log(type)
        if(type === 1){
          this.query.moduleTypeName = value;
          this.query.moduleType = value;
          this.query.subModuleId = '';
          this.getAllSubModuleList(value,this.query.projectId)
        } else if(type === 2){
          this.form.moduleTypeName = value;
          this.form.moduleType = value;
          this.form.subModuleId = '';
          this.query.subModuleId = '';
          this.getAllSubModuleList(value,this.form.projectId)
        }
        this.$forceUpdate();
      },
      modulesSetting(projectId){
        modulesSetting(projectId).then((data)=>{
          console.log(data);
          this.moduleTypeList = data.data;
          this.query.moduleTypeName = '';
          this.query.moduleType = '';
          this.form.moduleTypeName = '';
          this.form.moduleType = '';
          this.form.subModuleId = '';
          this.query.subModuleId = '';
        });
      },
      openList(row){
        this.listFlag = true;
        this.$refs.itemList.openItemListOnload(row.id,row.name);
      },
      projectChange(value){
        this.query.projectId = value;
        this.query.project = value;
        this.modulesSetting(value);
        this.$forceUpdate();
      },
      projectAddChange(value){
        this.form.projectId = value;
        this.form.project = value;
        this.modulesSetting(value);
        this.$forceUpdate();
      },
      rowSave(row, loading, done) {
        // console.log(row.subModuleId);
        // if (this.subModuleList && JSON.stringify(this.subModuleList)==="{}") {
        //
        // }else if(!this.subModuleList){
        //
        // }else{
        //   let status = false;
        //   this.subModuleList.forEach((value, index, array)=>{
        //     if(value.status === 1){
        //       status = true;
        //     }
        //   });
        //   if (!row.subModuleId && status) {
        //     this.$message.error("请选择'工单子类型'!");
        //     done();
        //     return;
        //   }
        // }
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        // if (this.subModuleList && JSON.stringify(this.subModuleList)==="{}") {
        // }else if(!this.subModuleList){
        // }else{
        //   let status = false;
        //   this.subModuleList.forEach((value, index, array)=>{
        //     if(value.status === 1){
        //       status = true;
        //     }
        //   });
        //   if (!row.subModuleId && status) {
        //     this.$message.error("请选择'工单子类型'!");
        //     done();
        //     return;
        //   }
        // }
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (type === 'edit') {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
            modulesSetting(data.projectId).then((res)=>{
              this.moduleTypeList = res.data;
            });
            this.getAllSubModuleList(data.moduleType,data.projectId);
            this.form.moduleTypeName = data.moduleType;
          });
        }
        if(type === 'view'){
          console.log(this.form);
          modulesSetting(this.form.projectId).then((res)=>{
            this.moduleTypeList = res.data;
          });
        }
        if(type === 'add'){
          setTimeout(()=>{
            this.form.projectId = this.projectList[0].id;
            this.form.project = this.projectList[0].name;
          })
        }
        done();
      },
      searchReset() {
        this.query.name = '';
        this.query.moduleTypeName = '';
        this.query.moduleType = '';
        this.query.subModuleId = '';
        this.onLoad();
      },
      searchChange(params,done) {
        // this.query = params;
        this.query.name = params.name;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
          console.log("this.query===============>",this.query);
        page = page || this.page;
        this.loading = true;
        if(this.query.projectId){
          console.log(this.query);
          getList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          });
        }else {
          getProjectList().then((data)=>{
            this.projectList = data.data;
            if(this.projectList.length > 0){
              this.query.projectId = this.projectList[0].id;
              this.query.project = this.projectList[0].name;
              this.modulesSetting(this.projectList[0].id);
              getList(
                Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
                this.selectionClear();
              });
            }
          });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
::v-deep .avue-form__item--{
  width:100%;
}
</style>
